import {Component} from '@angular/core'

@Component({
  selector: 'spb-income-cost-help',
  templateUrl: './income-cost-help.component.html',
  styleUrls: ['../help.scss']
})
export class IncomeCostHelpComponent {
}
